import { defineStore } from 'pinia';

// initial state for authentication
interface ConversationalState {
  elements: Array<{ intent: string }>;
}

/**
 * Pinia conversion of legacy vuex module `src/store/modules/conversational.ts` (namespace
 * `conversational`). In-memory only — the legacy module was never part of any `vuexLocal`/
 * `vuexSession` reducer in `src/store/index.ts`, so this store has NO `vuexPersist` option.
 *
 * Collisions & renames (see
 * `/private/tmp/claude-501/-Users-haslien-Documents-GitHub-moin-hub/23091b27-f9d9-4b85-91e6-ff6cd1c12710/scratchpad/pinia-migration/RENAMES.md`):
 * - Legacy had BOTH a state prop `elements` and a getter `elements` that is an identity passthrough
 *   of it. Per the state-prop/getter collision rule, the getter is renamed `elementsGetter`;
 *   consumers reading `elements` should now read `this.elements`/`store.elements` directly (the
 *   state prop), or use `elementsGetter` if they specifically called the getter.
 * - No actions or mutations existed in the legacy module (both were empty objects) — nothing to
 *   convert there.
 */
export const useConversationalStore = defineStore('conversational', {
  state: (): ConversationalState => ({
    elements: [
      {
        intent: 'start',
      },
      {
        intent: 'unknown',
      },
      {
        intent: 'next',
      },
      {
        intent: 'service',
      },
      {
        intent: 'faq_feedback',
      },
      {
        intent: 'smalltalk_thanks',
      },
      {
        intent: 'file_uploaded_not_requested',
      },
    ],
  }),
  getters: {
    /**
     * Renamed from legacy getter `elements` (collides with the state prop of the same name — the
     * state prop keeps the name). Identity passthrough kept for parity with the legacy getter.
     */
    elementsGetter(state): Array<{ intent: string }> {
      return state.elements;
    },
  },
  actions: {},
});
